import { render, staticRenderFns } from "./grouped_test_reports_app.vue?vue&type=template&id=0828d555&"
import script from "./grouped_test_reports_app.vue?vue&type=script&lang=js&"
export * from "./grouped_test_reports_app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports